'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n    min-height: 0;\n    width: 100% !important;\n  '], ['\n    min-height: 0;\n    width: 100% !important;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UISelectableBox = require('UIComponents/button/UISelectableBox');

var _UISelectableBox2 = _interopRequireDefault(_UISelectableBox);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _PricingSelectors = require('../../../selectors/PricingSelectors');

var _pricingUtils = require('../../../utils/pricingUtils');

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _ChargeTypes = require('self-service-api/constants/ChargeTypes');

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _UIGridItem = require('UIComponents/grid/UIGridItem');

var _UIGridItem2 = _interopRequireDefault(_UIGridItem);

var _responsiveBreakpoints = require('../../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

var _PriceDisplay = require('../../common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _merchandiseUtils = require('pricing-pages-unified-ui/utils/merchandiseUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Title = _styledComponents2.default.div.withConfig({
  displayName: 'OptionalItem__Title'
})(['font-size:14px;font-weight:600;']);

var StyledSelectableBox = (0, _styledComponents2.default)(_UISelectableBox2.default).withConfig({
  displayName: 'OptionalItem__StyledSelectableBox'
})(['min-height:220px;margin:12px 0;', ';'], _responsiveBreakpoints2.default.tablet(_templateObject));

function OptionalItem(_ref) {
  var merchandiseId = _ref.merchandiseId,
      selected = _ref.selected,
      onSelectedChange = _ref.onSelectedChange,
      pricingDependencies = _ref.pricingDependencies,
      currencyCode = _ref.currencyCode;

  var priceObject = (0, _pricingUtils.calculatePriceAndItemConfig)(_extends({}, pricingDependencies, {
    merchandiseId: merchandiseId
  }));
  var recurring = _ImmutableMerchandiseIdMap2.default[merchandiseId].chargeType === _ChargeTypes.RECURRING;
  var price = recurring ? priceObject.monthly.calculatedPrice : priceObject.oneTimeFee.calculatedPrice;

  var billingName = (0, _merchandiseUtils.billingNameKey)(merchandiseId);

  return _react2.default.createElement(
    _UIGridItem2.default,
    { size: { xs: 6 } },
    _react2.default.createElement(
      StyledSelectableBox,
      {
        selected: selected,
        onSelectedChange: onSelectedChange,
        type: 'checkbox'
      },
      _react2.default.createElement(
        'div',
        { className: 'text-start' },
        _react2.default.createElement(
          'div',
          { className: 'm-left-8' },
          _react2.default.createElement(
            _UIFlex2.default,
            { justify: 'between' },
            _react2.default.createElement(
              Title,
              null,
              _react2.default.createElement(_FormattedMessage2.default, {
                message: 'pricing-pages.merchandise.' + billingName + '.title'
              })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                Title,
                null,
                _react2.default.createElement(_PriceDisplay2.default, { price: price, currencyCode: currencyCode }),
                recurring && _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.priceDisplay.perMonth' })
              ),
              !recurring && _react2.default.createElement(
                _Small2.default,
                { use: 'help' },
                _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.notes.oneTimeFeeParentheses' })
              )
            )
          ),
          _react2.default.createElement(
            _Small2.default,
            null,
            _react2.default.createElement(_FormattedHTMLMessage2.default, {
              message: 'pricing-pages.merchandise.' + billingName + '.paragraph'
            })
          )
        )
      )
    )
  );
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    pricingDependencies: (0, _PricingSelectors.pricingDependenciesSelector)(state),
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(OptionalItem);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/optional-items/OptionalItem.js
// module id = 581
// module chunks = 3 4